export interface SubOption {
  title: string;
  value: string;
}

export interface AssetClassFilter {
  optionTitle: string;
  value: string;
  id: string;
  type: "check" | "radio";
  options: SubOption[];
}

export const assetClassAndProductFilterOptions: AssetClassFilter[] = [
  {
    optionTitle: "Agriculture",
    value: "AGRICULTURAL",
    id: "2",
    type: "check",
    options: [
      { title: "Commodity Indices", value: "Commodity Indices" },
      { title: "Dairy", value: "Dairy" },
      { title: "Fertilizer", value: "Fertilizer" },
      { title: "Grains", value: "Grains" },
      { title: "Livestock", value: "Livestock" },
      { title: "Lumber and Softs", value: "Lumber and Softs" },
      { title: "Oilseeds", value: "Oilseeds" },
    ],
  },
  {
    optionTitle: "Cryptocurrencies",
    value: "EQUITY-CRYPTO",
    id: "16",
    type: "check",
    options: [
      { title: "Bitcoin", value: "Bitcoin" },
      { title: "Ether", value: "Ether" },
      { title: "Ratio", value: "Ratio" }, // not verified
      { title: "Solana", value: "Solana" },
      { title: "XRP", value: "XRP" },
    ],
  },
  {
    optionTitle: "Energy",
    value: "ENERGY",
    id: "7",
    type: "check",
    options: [
      { title: "Biofuels", value: "Biofuels" },
      { title: "Coal", value: "Coal" },
      { title: "Crude Oil", value: "Crude Oil" },
      { title: "Electricity", value: "Electricity" }, // not verified
      { title: "Emissions", value: "Emissions" }, // not verified
      { title: "Freight", value: "Freight" }, // not verified
      { title: "Natural Gas", value: "Natural Gas" },
      { title: "Petrochemicals", value: "Petrochemicals" },
      { title: "Refined Products", value: "Refined Products" },
    ],
  },
  {
    optionTitle: "Equities",
    value: "EQUITY",
    id: "4",
    type: "check",
    options: [
      { title: "Dow Jones", value: "Dow Jones" },
      { title: "International Indices", value: "International Indices" },
      { title: "Nasdaq", value: "Nasdaq" },
      { title: "Russell", value: "Russell" },
      { title: "S&P", value: "S&P" },
      { title: "Select Sectors", value: "Select Sectors" },
      { title: "US Index", value: "US Index" },
    ],
  },
  {
    optionTitle: "FX",
    value: "FOREIGN EXCHANGE",
    id: "3",
    type: "check",
    options: [
      { title: "Cross Rates", value: "Cross Rates" },
      { title: "Emerging Market", value: "Emerging Market" },
      { title: "G10", value: "G10" },
    ],
  },
  {
    optionTitle: "Interest Rate",
    value: "INTEREST RATE",
    id: "1",
    type: "check",
    options: [
      { title: "Credit", value: "Credit" },
      { title: "Mortgage", value: "Mortgage" },
      { title: "Stirs", value: "STIRS" },
      { title: "Swap Futures", value: "Swap Futures" },
      { title: "US Treasury", value: "US Treasury" },
    ],
  },
  {
    optionTitle: "Metals",
    value: "METALS",
    id: "8",
    type: "check",
    options: [
      { title: "Base", value: "Base" },
      { title: "Battery Metals", value: "Battery Metals" },
      { title: "Ferrous", value: "Ferrous" },
      { title: "Other", value: "Other" },
      { title: "Precious", value: "Precious" },
    ],
  },
  {
    optionTitle: "Real Estate",
    value: "Real Estate",
    id: "11",
    type: "check",
    options: [],
  },
  {
    optionTitle: "Weather",
    value: "WEATHER",
    id: "5",
    type: "check",
    options: [
      { title: "CAT", value: "CAT" },
      { title: "CDD", value: "CDD" },
      { title: "HDD", value: "HDD" },
    ],
  },
];

export const exchanges = [
  {
    optionTitle: "CBOT",
    type: "check",
    id: "CBT",
  },
  {
    optionTitle: "CME",
    type: "check",
    id: "CME",
  },
  {
    optionTitle: "COMEX",
    type: "check",
    id: "COMEX",
  },
  {
    optionTitle: "DME",
    type: "check",
    id: "DME",
  },
  {
    optionTitle: "NYMEX",
    type: "check",
    id: "NYMEX",
  },
];

export const blockContents = [
  {
    optionTitle: "Futures",
    type: "check",
    id: "FUT",
  },
  {
    optionTitle: "Options",
    type: "check",
    id: "OPT",
  },
];
